module.exports = __webpack_public_path__ + "static/media/fly0274.baeb1ac4.webp";